<template>
  <div class="container">
    <!-- 订单金额 -->
    <div class="content">
      <div class="order-type">小麦助教标准版</div>
      <div class="order-price">￥{{2388 | toFixed(2)}}</div>
    </div>
    <!-- 支付渠道 -->
    <div class="pay-channel">
      <div class="channel" :class="[selectedChannel === 'ali' ? 'selected' : '']" @click="selected('ali')">
        <img :src="images.aliPay" alt="">
        <span class="text">支付宝</span>
        <span class="right"></span>
      </div>
      <div class="channel" :class="[selectedChannel === 'wechat' ? 'selected' : '']" @click="selected('wechat')">
        <img :src="images.wechatPay" alt="">
        <span class="text">微信支付</span>
        <span class="right"></span>
      </div>
    </div>
    <!-- 确认支付 -->
    <div class="footer">
      <div class="btn-pay">确认支付</div>
    </div>
  </div>
</template>
<script>
import aliPay from '@/images/renew/ali-pay.png';
import wechatPay from '@/images/renew/wechat-pay.png';

export default {
  data(){
    return {
      images: {
        aliPay,
        wechatPay
      },
      selectedChannel: 'wechat'
    }
  },
  methods: {
    selected(way) {
      this.selectedChannel = way;
    }
  }
}
</script>
<style lang="less" scoped>
.content{
  padding: 0.76rem 0;
  background-color: #fff;
  .order-type{
    font-size: 0.3rem;
  }
  .order-price{
    font-size: 0.76rem;
    font-weight: bold;
  }
}
.pay-channel{
  margin-top: 0.32rem;
  .channel{
    padding: 0.2rem 0.32rem;
    border-bottom: 1px solid #fafafa;
    text-align: left;
    background-color: #fff;
    img{
      width: 0.52rem;
      height: 0.52rem;
      vertical-align: middle;
    }
    .text{
      margin-left: 0.1rem;
      font-weight: 500;
      vertical-align: middle;
    }
    .right{
      float: right;
      margin: 0.1rem 0.1rem;
      width: 0.36rem;
      height: 0.36rem;
      background: url('~@/images/renew/pay-unselected.png') no-repeat;
      background-size: 100% 100%;
      transition: all 0.5s ease 0s;
    }
    &.selected {
      .right{
        background: url('~@/images/renew/pay-selected.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.footer{
  margin-top: 0.8rem;
  padding: 0 0.32rem;
  .btn-pay{
    padding: 0.24rem;
    border-radius: 0.1rem;
    color: #fff;
    font-size: 0.3rem;
    background: -webkit-linear-gradient(left, #FFAB1A , #ff8534); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #FFAB1A, #ff8534); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #FFAB1A, #ff8534); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #FFAB1A , #ff8534); /* 标准的语法 */
  }
}
</style>




// WEBPACK FOOTER //
// src/module/renew/pay.vue